export default __webpack_public_path__ + "static/media/moonriver.432932da.webp";